/** Match backend payroll run status strings (case-insensitive in UI). */
export enum PayrollRunStatus {
  DRAFT = "DRAFT",
  FINALIZED = "FINALIZED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export const payrollRunStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  [PayrollRunStatus.DRAFT]: { label: "Draft", color: "warning" },
  [PayrollRunStatus.FINALIZED]: { label: "Finalized", color: "info" },
  [PayrollRunStatus.PAID]: { label: "Paid", color: "success" },
  [PayrollRunStatus.CANCELLED]: { label: "Cancelled", color: "danger" },
};

export function isPayrollRunDraft(status: string | undefined): boolean {
  if (!status) return true;
  return status === PayrollRunStatus.DRAFT || status === "pending" || status === "open" || status === "";
}

export function isPayrollRunFinalized(status: string | undefined): boolean {
  if (!status) return false;
  return status === PayrollRunStatus.FINALIZED;
}

export function isPayrollRunPaid(status: string | undefined): boolean {
  if (!status) return false;
  return status === PayrollRunStatus.PAID;
}

export function canCancelPayrollRun(status: string | undefined): boolean {
  return isPayrollRunFinalized(status);
}

/** Bulk-pay every employee in the run — only while it's FINALIZED (never inferred from items). */
export function canPayPayrollRun(status: string | undefined): boolean {
  return isPayrollRunFinalized(status);
}

/** Match backend payroll item status strings. */
export enum PayrollItemStatus {
  DRAFT = "DRAFT",
  FINALIZED = "FINALIZED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
}

export const payrollItemStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  [PayrollItemStatus.DRAFT]: { label: "Draft", color: "warning" },
  [PayrollItemStatus.FINALIZED]: { label: "Finalized", color: "info" },
  [PayrollItemStatus.PAID]: { label: "Paid", color: "success" },
  [PayrollItemStatus.CANCELLED]: { label: "Cancelled", color: "danger" },
};

export function canPayPayrollItem(status: string | undefined): boolean {
  return status === PayrollItemStatus.FINALIZED;
}
